export enum Breakpoint {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
  xxl = 'xxl',
  fullhd = 'fullhd',
  ultrahd = 'ultrahd',
}

export type Breakpoints = Record<Breakpoint, number>
